<!-- Novo pedir.delivery (controlado por restaurant.info.modules.new_home_pedir_delivery) -->
<ng-container *ngIf="isNewHomePedirDelivery">
	<div class="menu-header header-component" [class.new-design-font]="isNewHomePedirDelivery">
		<div *ngIf="restaurant.info.cover_pic" class="header-component__cover" [ngClass]="{'header-component__cover--has-image': true, 'header-component__cover--blocked': isRestaurantBlocked}">
			<!-- A capa é o maior elemento do topo quando existe: é ela que vira o LCP. -->
			<img class="header-component__cover-img" [src]="imgCover" [attr.srcset]="imgCoverSrcset" sizes="100vw" [attr.data-original]="imgCoverOriginal" alt="" fetchpriority="high" />
		</div>

		<div class="header-component__card" [ngClass]="{'header-component__card--no-cover': !restaurant.info.cover_pic}">
			<div class="header-component__row header-component__row--main">
				<div *ngIf="restaurant.info.profile_pic" class="header-component__logo">
					<!-- Com capa, o logo cede a banda para ela: no SSR os dois saem no mesmo HTML e o logo
					     (até 400 KB, exibido em 74 px) atrasava o LCP. Sem capa, o logo pode ser o LCP. -->
					<img [src]="imgProfile" [attr.data-original]="imgProfileOriginal" alt="" class="header-component__logo-img" [class.header-component__logo-img--blocked]="isRestaurantBlocked" [attr.fetchpriority]="restaurant.info.cover_pic ? 'low' : null">
				</div>
				<h2 class="header-component__name">{{ restaurant.info.name }}</h2>
				<button type="button" class="header-component__info-btn" (click)="openInfo()" data-cy="infoLink">
					<svg class="header-component__icon header-component__icon--svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
						<circle cx="12" cy="12" r="10"/>
						<line x1="12" y1="16" x2="12" y2="12"/>
						<line x1="12" y1="8" x2="12.01" y2="8"/>
					</svg>
					<span translate>Information</span>
				</button>
			</div>

			<div class="header-component__body">
				<div class="header-component__body-left">
					<div class="header-component__row header-component__row--address" *ngIf="!restaurant.info.no_takeout">
						<img src="assets/icon/gps-pin-small.svg" alt="" class="header-component__icon header-component__icon--svg" />
						<a class="header-component__address" target="_blank" [href]="'https://www.google.com/maps/search/?api=1&query=\'' + restaurant.info.street + ', ' + restaurant.info.street_number + ' - ' + restaurant.info.bairro + ' - ' + restaurant.info.city + '/' + restaurant.info.uf + '\''">
							{{ restaurant.info.street }}, {{ restaurant.info.street_number }} - {{ restaurant.info.bairro }} - {{ restaurant.info.city }}/{{ restaurant.info.uf }}
						</a>
					</div>

					<!-- Horário e selo aberto/fechado: só depois da hidratação (ver `posHidratacao`). A
					     classe --reservada guarda a altura da linha enquanto isso, para nada pular. -->
					<div class="header-component__row header-component__row--hours" [class.header-component__row--reservada]="!posHidratacao">
						<ng-container *ngIf="posHidratacao">
						<svg *ngIf="!isRestaurantBlocked && getTodayHoursDisplay()" class="header-component__icon header-component__icon--svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
							<circle cx="12" cy="12" r="10"/>
							<polyline points="12 6 12 12 16 14"/>
						</svg>
						<span class="header-component__hours" *ngIf="!isRestaurantBlocked && getTodayHoursDisplay()">{{ getTodayHoursDisplay() }}</span>

						<span class="header-component__status header-component__status--open" *ngIf="!isRestaurantBlocked && (!restaurant.info.is_closed || debugMode)">
							<span class="header-component__status-dot"></span>
							<span translate>Open now</span>
						</span>
						<span class="header-component__status header-component__status--closed" *ngIf="isRestaurantBlocked || (restaurant.info.is_closed && !debugMode && (!restaurant.info.scheduleSettings?.allowSchedulingWhileClosed || !restaurant.info.scheduleSettings?.enable))">
							<span class="header-component__status-dot"></span>
							<span translate>Close</span>
						</span>
						<span class="header-component__status header-component__status--schedule" *ngIf="!isRestaurantBlocked && restaurant.info.is_closed && !debugMode && restaurant.info.scheduleSettings?.allowSchedulingWhileClosed && restaurant.info.scheduleSettings?.enable">
							<span class="header-component__status-dot"></span>
							<span translate>Open for schedule</span>
						</span>
						</ng-container>
					</div>

					<div class="header-component__row header-component__row--delivery" *ngIf="!isRestaurantBlocked">
						<span class="header-component__delivery-item" *ngIf="restaurant?.info?.delivery_time_min > 0 && !restaurant?.info?.no_delivery">
							<img src="assets/icon/motoboy-helmet.svg" alt="" class="header-component__icon header-component__icon--svg" />
							{{ 'Delivery' | translate }}: {{ timeConvert(restaurant?.info?.delivery_time_min) }} - {{ timeConvert(restaurant?.info?.delivery_time_max) }}
						</span>
						<span class="header-component__delivery-item" *ngIf="!restaurant?.info?.no_takeout && restaurant?.info?.takeout_time > 0">
							<img src="assets/icon/takeout-icon.svg" alt="" class="header-component__icon header-component__icon--svg" />
							{{ 'Takeout' | translate }}: {{ timeConvert(restaurant.info.takeout_time) }}
						</span>
					</div>
				</div>

				<button
					*ngIf="restaurant.info.review_settings?.enabled && restaurant.info.review_settings?.show_in_order_page && restaurant.info.rating_average"
					class="header-component__rating"
					type="button"
					(click)="openReviews()"
					data-cy="reviewsLink">
					<img src="assets/icon/star.svg" alt="" class="header-component__rating-star" />
					<span class="header-component__rating-value">{{ restaurant.info.rating_average | number:'1.1-1' }}</span>
				</button>
			</div>

			<div class="header-component__disclaimer" *ngIf="restaurant?.info?.message">
				<span class="header-component__disclaimer-text">{{ restaurant.info.message }}</span>
			</div>
		</div>
	</div>
</ng-container>

<!-- Layout antigo — RECRIADO sem Ionic (mp-*): fiel ao ion-row/col/card/content/text/icon.
     Classes utilitárias do Ionic (ion-justify-content-*, ion-no-padding, ion-padding, ion-no-margin)
     são só CSS (flex-utils/padding.css) — mantidas. ion-icon → SVG inline com currentColor. -->
<ng-container *ngIf="!isNewHomePedirDelivery">
	<div class="header-legacy menu-header pb-1">
		<div [style.background-image]="restaurant.info.cover_pic ? imgCoverStyle : ''" [ngClass]="{'overlay cover-photo': restaurant.info.cover_pic}">
			<div *ngIf="posHidratacao && !currentTable">
				<svg *ngIf="!isLoggedIn" class="mp-icon mp-icon--large icon-login" viewBox="0 0 512 512" fill="currentColor" [style.color]="restaurant.info.cover_pic ? '#FFF' : '#000'" (click)="goToLogin()" aria-hidden="true"><path d="M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48m126.42 327.25a4 4 0 0 1-6.14-.32 124.3 124.3 0 0 0-32.35-29.59C321.37 329 289.11 320 256 320s-65.37 9-90.83 25.34a124.2 124.2 0 0 0-32.35 29.58 4 4 0 0 1-6.14.32A175.32 175.32 0 0 1 80 259c-1.63-97.31 78.22-178.76 175.57-179S432 158.81 432 256a175.32 175.32 0 0 1-46.68 119.25"/><path d="M256 144c-19.72 0-37.55 7.39-50.22 20.82s-19 32-17.57 51.93C191.11 256 221.52 288 256 288s64.83-32 67.79-71.24c1.48-19.74-4.8-38.14-17.68-51.82C293.39 151.44 275.59 144 256 144"/></svg>
				<svg *ngIf="isLoggedIn" class="mp-icon mp-icon--large icon-login" viewBox="0 0 512 512" fill="currentColor" [style.color]="restaurant.info.cover_pic ? '#FFF' : '#000'" (click)="confirmLogout()" aria-hidden="true"><path d="M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48m126.42 327.25a4 4 0 0 1-6.14-.32 124.3 124.3 0 0 0-32.35-29.59C321.37 329 289.11 320 256 320s-65.37 9-90.83 25.34a124.2 124.2 0 0 0-32.35 29.58 4 4 0 0 1-6.14.32A175.32 175.32 0 0 1 80 259c-1.63-97.31 78.22-178.76 175.57-179S432 158.81 432 256a175.32 175.32 0 0 1-46.68 119.25"/><path d="M256 144c-19.72 0-37.55 7.39-50.22 20.82s-19 32-17.57 51.93C191.11 256 221.52 288 256 288s64.83-32 67.79-71.24c1.48-19.74-4.8-38.14-17.68-51.82C293.39 151.44 275.59 144 256 144"/></svg>
				<label data-cy="userLogin" *ngIf="!isLoggedIn" class="pointer label-login" [style.color]="restaurant.info.cover_pic ? '#FFF' : '#000'" (click)="goToLogin()" translate>Login</label>
				<label data-cy="userLogout" *ngIf="isLoggedIn" class="pointer label-logout" [style.color]="restaurant.info.cover_pic ? '#FFF' : '#000'" (click)="confirmLogout()" translate>Logout</label>
			</div>
			<div class="profile-image" *ngIf="restaurant.info.profile_pic">
				<img class="profile" [style.margin-top]="restaurant.info.cover_pic ? '100px' : '10px'" [src]="imgProfile" [attr.data-original]="imgProfileOriginal">
			</div>
		</div>
		<div class="info-box p-3" [ngClass]="{'mt-5': restaurant.info.cover_pic}">

			<div class="main-info" [ngClass]="{'image-margin-top': hasImages, 'no-image-margin-top': hasNoImages}">
				<h3 class="m-1 font-weight-bold">{{restaurant.info.name}}</h3>

				<p class="mb-2" data-cy="takeoutInfo" *ngIf="!restaurant.info.no_takeout">
					<a target="_blank" href="https://www.google.com/maps/search/?api=1&query='{{restaurant.info.street}}, {{restaurant.info.street_number}} - {{restaurant.info.bairro}} - {{restaurant.info.city}} / {{restaurant.info.uf}}'">
						{{restaurant.info.street}}, {{restaurant.info.street_number}} - {{restaurant.info.bairro}} - {{restaurant.info.city}}/{{restaurant.info.uf}}
					</a>
				</p>
			</div>

			<div class="extra-info">
				<div class="mp-row ion-justify-content-center" style="font-size: 15px;">
					<div (click)="openReviews()" class="mp-col mp-col-4 ion-no-padding ion-align-items-center ion-justify-content-center" *ngIf="restaurant.info.review_settings.enabled && restaurant.info.review_settings.show_in_order_page && restaurant.info.rating_average">
						<p style="margin-bottom: 0px;" data-cy="reviewsLink" translate>Reviews</p>
						<p style="margin-bottom: 0px !important; font-size: 16px; font-weight: 600;cursor: pointer; font-family: Arial, Helvetica, sans-serif;" class="alignStar">{{ restaurant.info.rating_average }} <svg class="mp-icon mp-icon--small pl-1" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" aria-hidden="true"><path d="M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160Z" stroke-linejoin="round"/></svg></p>
					</div>
					<div class="mp-col mp-col-4 ion-no-padding" data-cy="deliveryTime" *ngIf="restaurant?.info?.delivery_time_min>0 && !restaurant?.info?.no_delivery">
						<p style="margin-bottom: 0px;" translate>Delivery</p>
						<p class="description mb-1">{{timeConvert(restaurant.info.delivery_time_min)}} - {{timeConvert(restaurant.info.delivery_time_max)}}</p>
					</div>
					<div class="mp-col mp-col-4 ion-no-padding" data-cy="takeoutTime" *ngIf="!restaurant?.info?.no_takeout && restaurant?.info?.takeout_time>0">
						<p style="margin-bottom: 0px;" translate>Takeout</p>
						<p class="description mb-1">{{timeConvert(restaurant.info.takeout_time)}}</p>
					</div>
				</div>
				<div class="mp-row ion-justify-content-center ion-align-items-center" style="font-size: 15px;">
					<div class="mp-col mp-col-4">
						<div (click)="openPayments()">
							<p style="margin-bottom: 0px;" data-cy="paymentsLink" translate>Payments</p>
							<svg class="mp-icon icon-payments" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" aria-hidden="true"><rect width="416" height="320" x="48" y="96" rx="56" ry="56" stroke-linecap="round" stroke-linejoin="round"/><path d="M48 192h416M128 300h48v20h-48z" stroke-linejoin="round" stroke-width="60"/></svg>
						</div>
					</div>
					<div class="mp-col mp-col-4">
						<div (click)="openHours()">
							<p style="margin-bottom: 0px;" data-cy="hoursLink" translate>Hours</p>
							<svg class="mp-icon icon-hours" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" aria-hidden="true"><path d="M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64Z" stroke-miterlimit="10"/><path d="M256 128v144h96" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</div>
					</div>
					<div class="mp-col mp-col-4">
						<div (click)="openInfo()">
							<p style="margin-bottom: 0px;" data-cy="infoLink" translate>Information</p>
							<svg class="mp-icon icon-info" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" aria-hidden="true"><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192Z" stroke-miterlimit="10"/><path d="M256 176v160M336 256H176" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</div>
					</div>
				</div>

				<div class="mp-row">
					<div class="mp-col mp-col-12 text-center">
						<p class="title mb-0" translate>Operation</p>
						<!-- Aberto/fechado só depois da hidratação (ver `posHidratacao`); o contêiner
						     guarda a altura da linha para o cardápio não pular quando ela entra. -->
						<div class="header-legacy__operacao">
						<ng-container *ngIf="posHidratacao">
						<label *ngIf="!restaurant.info.is_closed || debugMode" class="description text-success font-weight-bold" style="letter-spacing: 1.5px;" translate>OPEN</label>
						<label *ngIf="restaurant?.info?.is_closed && !debugMode && (!restaurant?.info?.scheduleSettings?.allowSchedulingWhileClosed || !restaurant?.info?.scheduleSettings?.enable)" class="description text-danger font-weight-bold" style="letter-spacing: 1.5px;" translate>CLOSE</label>
						<label *ngIf="restaurant?.info?.is_closed && restaurant?.info?.scheduleSettings?.allowSchedulingWhileClosed && restaurant?.info?.scheduleSettings?.enable" class="description fort-weight-bold" style="letter-spacing: 1.5px; color: #ffbe00;" translate>OPEN FOR SCHEDULE</label>
						</ng-container>
						</div>
					</div>
				</div>

				<div class="mp-row highlight-image-slider" *ngIf="highlightImages">
					<div class="mp-col mp-col-12 text-center">
						<swiper-container data-cy="highlightImageSlider" pagination="true" autoplay="true" loop="true" style="--swiper-pagination-bullet-inactive-color: white; --swiper-pagination-bullet-inactive-opacity: 1; --swiper-pagination-color: rgb(255, 60, 0);">
							<!-- Uma foto por vez: a 1ª tem prioridade (é o maior elemento do topo); as outras
							     esperam ela chegar e então carregam em segundo plano, para estarem prontas quando
							     o carrossel girar. Ver `liberarDestaques`. -->
							<swiper-slide *ngFor="let image of highlightImages; let i = index">
								<img class="highlight-image" [src]="urlDoDestaque(image.image)" [attr.data-original]="originalDoDestaque(image.image)"
									[attr.loading]="i === 0 || destaquesLiberados ? 'eager' : 'lazy'"
									[attr.fetchpriority]="i === 0 ? 'high' : null"
									(load)="i === 0 && liberarDestaques()"
									(error)="i === 0 && liberarDestaques()"/>
							</swiper-slide>
						</swiper-container>
					</div>
				</div>

				<div class="mp-row" *ngIf="restaurant?.info?.message">
					<div class="mp-col mp-col-12 ion-no-padding">
						<div class="mp-card restaurantMessage ion-no-margin">
							<div class="mp-card-content ion-padding">
								<span class="mp-text" data-cy="restaurantMessage" style="font-size: 14px; white-space: pre-line;">
									{{restaurant.info.message}}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mp-row" *ngIf="posHidratacao && hasMisingPayment">
					<div class="mp-col mp-col-12 ion-no-padding">
						<div class="mp-card restaurantMessage ion-no-margin">
							<div class="mp-card-content ion-padding">
								<span class="mp-text" style="font-size: 14px;" translate>
									Order has missing Mercadopago payment
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
